// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';

// ===== Interfaces =====

import {
    IAnnotationItemDetached,
    IAnnotationQuote,
    IAnnotationValue,
}                               from '../interfaces';

const updateAnnotation = async ({
    test,
    annotationId,
    mediaIds,
    historyToAdd,
    quoteHistoryToAdd,
    detached,
    viewsToAdd,
    playsToAdd,
}: {
    test: boolean,
    annotationId: string,
    mediaIds?: string[],
    historyToAdd?: IAnnotationValue[],
    quoteHistoryToAdd?: IAnnotationQuote[],
    detached?: IAnnotationItemDetached,
    viewsToAdd?: string[],
    playsToAdd?: string[],
}): Promise<boolean> => {
    const functions = getFunctions();
    const handleUpdateAnnotation = httpsCallable<
        Record<
            string,
            | boolean
            | string
            | string[]
            | IAnnotationItemDetached
            | IAnnotationValue[]
            | IAnnotationQuote[]
            | undefined
        >,
        boolean
    >(
        functions,
        'updateAnnotation',
    );
    return handleUpdateAnnotation({
        test,
        annotationId,
        mediaIds,
        historyToAdd,
        quoteHistoryToAdd,
        detached,
        viewsToAdd,
        playsToAdd,
    }).then((result) => {
        const success = result.data as boolean;
        return success;
    }).catch((err) => {
        throw err;
    });
};

export default updateAnnotation;
